import { listMethod } from "./resource";
const resource = "autocomplete/addresses";
export const list = (client, request) => listMethod({ resource, client })(request);
